// extracted by mini-css-extract-plugin
export var container = "_6m-0";
export var infoButton = "_6m-1";
export var label = "_6m-3";
export var labelExpanded = "_6m-4";
export var price = "_6m-5";
export var priceExpanded = "_6m-6";
export var title = "_6m-2";